import React, { useEffect, useRef, createElement } from 'react';
import { motion } from 'framer-motion';
export function VideoSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    let scriptsLoaded = false;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && !scriptsLoaded) {
        scriptsLoaded = true;
        const playerScript = document.createElement('script');
        playerScript.src = 'https://fast.wistia.com/player.js';
        playerScript.async = true;
        document.head.appendChild(playerScript);
        const embedScript = document.createElement('script');
        embedScript.src = 'https://fast.wistia.com/embed/mipuj1mgsw.js';
        embedScript.async = true;
        embedScript.type = 'module';
        document.head.appendChild(embedScript);
        observer.disconnect();
      }
    }, {
      rootMargin: '200px'
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="py-20 bg-white" data-id="element-414">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-415">
        <div className="text-center mb-12" data-id="element-416">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-417">
            Mira Cómo Se Preparan Nuestros Productos
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-600" data-id="element-418">
            Simple, rápido y delicioso
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-419">
          <div ref={el => {
          if (el && !el.querySelector('wistia-player')) {
            const style = document.createElement('style');
            style.textContent = "wistia-player[media-id='mipuj1mgsw']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/mipuj1mgsw/swatch'); display: block; filter: blur(5px); padding-top:177.78%; }";
            el.appendChild(style);
            const player = document.createElement('wistia-player');
            player.setAttribute('media-id', 'mipuj1mgsw');
            player.setAttribute('aspect', '0.5625');
            el.appendChild(player);
          }
        }} data-id="element-420" />
        </motion.div>
      </div>
    </section>;
}